import React, { useEffect, useState } from "react";
import Allergies from '../../../../globalcomponents/patient360/medicalhistory/allergies'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
const PatientAllergies = (props) => {
  return (
    <>
      <Allergies data={props.formValues.patientdata} app="Patient" />
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    formValues: state.form,
    state
  }
}

export default withRouter(connect(mapStateToProps, null)(PatientAllergies));

